import { Column, Entity, Index, OneToMany } from 'typeorm';
import { ApiConfigurationDetailEntity } from './api-configuration-detail.entity';
import { ApiConfigurationParameterEntity } from './api-configuration-parameter.entity';
import { ApiConfigurationRbacActionEntity } from './api-configuration-rbac-action.entity';
import { BaseEntity } from './base.entity';

@Index(
	'_api_configuration__unique',
	['alias', 'module', 'fkObjectIdReference', 'referenceId'],
	{ unique: true },
)
@Entity('_api_configuration')
export class ApiConfigurationEntity extends BaseEntity {
	@Column('varchar', { name: '_alias', nullable: true, length: 140 })
	public alias!: string | null;

	@Column('varchar', {
		name: '_module',
		nullable: true,
		length: 50,
		default: () => "'instance'",
	})
	public module!: string | null;

	@Column('varchar', { name: '_hook', nullable: true, length: 20 })
	public hook!: string | null;

	@Column('varchar', { name: '_hook_alias', nullable: true, length: 50 })
	public hookAlias!: string | null;

	@Column('varchar', { name: '_hook_module', nullable: true, length: 50 })
	public hookModule!: string | null;

	@Column('int', {
		name: '_hook_ordinal',
		nullable: true,
		unsigned: true,
		default: () => "'10'",
	})
	public hookOrdinal!: number | null;

	@Column('int', { name: '_delegate_userId', nullable: true, unsigned: true })
	public delegateUserId!: number | null;

	@Column({
		type: 'boolean',
		name: '_isPassthrough',
		nullable: true,
		width: 1,
		default: () => "'0'",
	})
	public isPassthrough!: boolean | null;

	@Column('varchar', { name: '_bodyType', length: 16 })
	public bodyType!: string;

	@Column('int', {
		name: '_fk__object__id_reference',
		unsigned: true,
		default: () => "'0'",
	})
	public fkObjectIdReference!: number;

	@Column('int', { name: '_referenceId', unsigned: true, default: () => "'0'" })
	public referenceId!: number;

	@OneToMany(
		() => ApiConfigurationDetailEntity,
		(apiConfigurationDetail) => apiConfigurationDetail.fkApiConfiguration,
		{},
	)
	public apiConfigurationDetails!: Array<ApiConfigurationDetailEntity>;

	@OneToMany(
		() => ApiConfigurationParameterEntity,
		(apiConfigurationParameter) => apiConfigurationParameter.fkApiConfiguration,
		{},
	)
	public apiConfigurationParameters!: Array<ApiConfigurationParameterEntity>;

	@OneToMany(
		() => ApiConfigurationRbacActionEntity,
		(apiConfigurationRbacAction) =>
			apiConfigurationRbacAction.fkApiConfiguration,
		{},
	)
	public apiConfigurationRbacActions!: Array<ApiConfigurationRbacActionEntity>;
}
